import factory from '../requestFactory';

export default ({login,password}) => {
    return factory()
        .post('/patient/check-credentials', {
            login, password
        });
}
